import { render, staticRenderFns } from "./CenterComponent.vue?vue&type=template&id=2b332658&"
import script from "./CenterComponent.vue?vue&type=script&lang=js&"
export * from "./CenterComponent.vue?vue&type=script&lang=js&"
import style0 from "./CenterComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports